<template>
    <PerfilSga v-if="teatro.sga === 1" />
    <Perfil v-else-if="manager.lfp === 1" />
    <PerfilV2 v-else />
</template>

<script>
    import PerfilSga from '@/components/frontend/perfil/PerfilSga';
    import Perfil from '@/components/frontend/perfil/Perfil';
    import PerfilV2 from '@/modules/front/perfil/views/PerfilV2.vue';

    export default {
        components: {
            PerfilSga, Perfil, PerfilV2
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            },
            manager() {
                return this.$store.getters.getFooter;
            }
        }
    }
</script>
